export default [
  { key: 'name', val: 'Name' },
  { key: 'status', val: 'Status' },
  { key: 'amount', val: 'Amount' },
];
